import { CommonModule } from '@angular/common';
import { Component, NgModule, OnInit } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';


import { TranslateService } from '@codeandweb/ngx-translate';

import { TableModule } from '@app/primeng-overrides/table';
import { AccordionModule } from 'primeng/accordion';
import { ButtonModule } from 'primeng/button';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { GlobalModule } from '@app/_global/global.module';
import { NomenclatureService } from '@app/nomenclature/nomenclature.service';
import { Utilisateur } from '@app/utilisateur/utilisateur.model';
import { EventManagerService, IEventListener } from '@global/event-manager.service';
import { ReadonlyTextDialogComponent } from '../readonly-texte-dialog';
import { InfoTexteModification, Texte } from '../texte.model';

import { uid } from '@helpers/utils';

@Component({
	selector: 'linked-textes-dialog',
	templateUrl: './linked-textes-dialog.html',
	providers: []
})
export class LinkedTextesDialogComponent implements OnInit, IEventListener {

	private _uuid: string = uid();
	get uuid(): string { return this._uuid; }

	liste: InfoTexteModification[];
	mode: 'targeted' | 'modifying'
	me: Utilisateur;

	constructor(
		private config: DynamicDialogConfig,
		private nomenclatureService: NomenclatureService,
		private eventManager: EventManagerService,
		private translateService: TranslateService,
		private dialogRef: DynamicDialogRef,
		private dialogService: DialogService,
	) {
		this.liste = config.data.liste;
		this.mode = config.data.mode;
		this.me = config.data.me;
	}

	ngOnInit(): void {
		this.eventManager.registerEvent('close-modals', this, (args: any) => this.dialogRef.close());
	}

	ngOnDestroy(): void {
		this.eventManager.unregisterEvent('close-modals', this);
	}

	replaceModalWithTextModal(txt_id: number) {
		this.dialogRef.close();
		
		this.nomenclatureService.getTexte(txt_id)
		.subscribe((texte: Texte) => {
			this.dialogService.open(ReadonlyTextDialogComponent, {
				header: texte.txt_reference,
				width: '85%',
				data: {
					me: this.me,
					texte: texte
				},
			});
		})
	}
}


@NgModule({
	imports: [
		CommonModule,
		UIRouterModule,
		GlobalModule,
		ButtonModule,
		TableModule,
		AccordionModule,
	],
	exports: [LinkedTextesDialogComponent],
	declarations: [LinkedTextesDialogComponent]
})
export class LinkedTextesDialogModule { }

